import { render, staticRenderFns } from "./clientCategoriesComponent.vue?vue&type=template&id=771f7822&scoped=true"
import script from "./clientCategoriesComponent.vue?vue&type=script&lang=js"
export * from "./clientCategoriesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771f7822",
  null
  
)

export default component.exports